import type { ConsentCategories } from "./types";

// SH-0221: consent accept-rate measurement. The durable consent log (KV) only
// held decisions, so there was no denominator. `banner_shown` is the
// impression; `action` classifies each decision. Accept rate =
// accept_all / banner_shown, queryable from function logs / KV.
export type ConsentAction = "accept_all" | "reject_all" | "custom";

export function deriveConsentAction(c: ConsentCategories): ConsentAction {
  if (c.analytics && c.marketing && c.functional) return "accept_all";
  if (!c.analytics && !c.marketing && !c.functional) return "reject_all";
  return "custom";
}

const SHOWN_KEY = "letsloop-consent-shown-v1";

/** Fire-and-forget impression ping, at most once per browser session. */
export function logBannerShown(): void {
  if (typeof window === "undefined") return;
  try {
    if (window.sessionStorage.getItem(SHOWN_KEY)) return;
    window.sessionStorage.setItem(SHOWN_KEY, "1");
  } catch {
    // storage unavailable: still send once per page load
  }
  try {
    void fetch("/api/consent-log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event: "consent.banner_shown",
        timestamp: Date.now(),
      }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // fire-and-forget
  }
}
